import { Templates } from '../../compile';
import { ColumnOptions } from '../../interfaces/options/column';
import { Align } from '../../enums/align';

export const DefaultColumnOptions: ColumnOptions<any> = {
	key: null,
	headerTemplate: Templates.table_column_header,
	autoWidth: false,
	headerAlign: Align.LEFT,
	cellAlign: Align.LEFT
};
